import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DropdownFormElementModel } from '@app/clinical-feedback/clinical-feedback.model';
import { NewClinicalFeedbackFormHelper } from '@app/clinical-feedback/new-clinical-feedback/new-clinical-feedback.helper';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
    @Input() parentFormGroup!: UntypedFormGroup;
    @Input() formElementModel!: DropdownFormElementModel;

    get control() {
        if (!this.formElementModel.id) {
            throw new Error(`formElementId not set for '${this.formElementModel.label}'.`);
        }

        return this.parentFormGroup.get(this.formElementModel.id);
    }

    get asterisk() {
        return NewClinicalFeedbackFormHelper.getAsteriskIfRequired(this.control);
    }
}
